import { ArtworkResult } from "kreate-server/commands/GetArtworkList/typing";

export function getArtworkInventory(
  artwork: ArtworkResult
): { available: number; price: number } | undefined {
  if (artwork.utxo?.datum.type === "artwork") {
    return {
      available:
        artwork.utxo.datum.value.numEditions -
        artwork.utxo.datum.value.numMinted,
      price: artwork.utxo.datum.value.mintFee,
    };
  }

  if (artwork.utxo?.datum.type === "marketplace") {
    return {
      available: artwork.utxo.otherAssets?.[0]?.tokens[0]?.tokenValue || 0,
      price: artwork.utxo.datum.value.editionPrice,
    };
  }

  if (artwork.mintingRules?.version === 1) {
    return {
      available:
        artwork.mintingRules.numEditions - artwork.mintingRules.numMinted,
      price: artwork.mintingRules.mintFee,
    };
  }

  return undefined;
}
